// extracted by mini-css-extract-plugin
export default {"wrapper":"So","form":"To","required":"Uo","label":"Vo","noMargin":"Wo","success":"Xo","circle":"Yo","successText":"Zo","smallprint":"_o"};